import { render, staticRenderFns } from "./AddressEditor.vue?vue&type=template&id=9d6d08aa&scoped=true"
import script from "./AddressEditor.vue?vue&type=script&lang=js"
export * from "./AddressEditor.vue?vue&type=script&lang=js"
import style0 from "./AddressEditor.vue?vue&type=style&index=0&id=9d6d08aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6d08aa",
  null
  
)

export default component.exports